/**
 * Object Logr specifický pro DEVELOP prostředí
 */
import { IGLogger, IGLoggerStatic, LogMessage, LogLevel } from "./common"
// import { serverTransport } from "./transport"

const nativeConsole = window.console;

export const GLogger: IGLoggerStatic = function (this: IGLogger, author: string, tag?: string) {
    if (!author) {
        throw new Error(`Parameter author must be non empty string.`)
    }

    this.author = author
    this.tag = tag
    this.tagName = author + (tag ? "/" + tag : "") + " \u00BB"
} as any;

// Logr má v prototypu nativní console
GLogger.prototype = Object.create(nativeConsole)

// serverTransport je zveřejněný jako statická vlastnost Logr
// (GLogger as any).serverTransport = serverTransport;

GLogger.prependAuthorInfo = true

// prázdná funkce, pro instance, které jsou supress
const toVoid = function () { }

// kolekce jmen všech metod na nativní console, bude se měnit jejich accessor
const consoleMethods = Object.keys(nativeConsole).filter(
    prop => typeof nativeConsole[prop] === "function")

// kolekce metod, které vyvolávají textový výstup a lze je bezpečně ovlivnit 
// bindováním prvního parametru na author/tag
const consoleMethodWithTextOutput = ["debug", "error", "info", "log", "warn"
    , "dir", "dirxml", "table", "trace", "group", "groupCollapsed"]

// všechny metody, které Logr zdědil z console, se přetíží tak, že pokud
// je instance Logr supress, vrací místo metody console prázdnou funkci
Object.defineProperties(GLogger.prototype, consoleMethods.reduce(
    (descriptor, prop) => {
        const nativeMethod = nativeConsole[prop];
        descriptor[prop] = {
            get(this: IGLogger) {
                if (GLogger.supress && GLogger.supress(this.author, this.tag)) {
                    return toVoid;
                }
                if (GLogger.prependAuthorInfo) {
                    // bind metod je drahé, proto se provádí jenom jednou
                    // pro každou instanci a ukládá jako _bound-method

                    // většina volání rovnou returnuje metodu z chache
                    return this[`_bound-${prop}`]
                        // pokud není cache, jedná se buď o metodu, které
                        // nelze svázat parametr pomocí bind
                        || consoleMethodWithTextOutput.indexOf(prop) === -1
                            ? nativeMethod
                            // nebo cache ještě nebyla vytvořená
                            : (this[`_bound${prop}`] = nativeMethod.bind(nativeConsole, this.tagName))
                            ;
                }
                return nativeMethod;
            }
        };

        return descriptor;
    }, {} as PropertyDescriptorMap
));

function toSerialized (input: any) {
    return typeof input === "object" ? JSON.stringify(input) : input
}

//GLogger.prototype._serverLog = function (this: IGLogger, level: LogLevel, ...messages: any[]): void {
//    if (messages && messages.length && messages[0] != null) {
//        serverTransport.append({
//            level
//            , message: messages.map(toSerialized).join(", ")
//            , logger: this.tagName
//            , timeStamp: Date.now()
//        });
//    }
//};

//GLogger.prototype.sTrace = function (this: any, ...logItems: any[]) {
//    this._serverLog(LogLevel.Trace, logItems);
//};

//GLogger.prototype.sDebug = function (this: any, ...logItems: any[]) {
//    this._serverLog(LogLevel.Debug, logItems);
//};

//GLogger.prototype.sInfo = GLogger.prototype.sLog = function (this: any
//    , ...logItems: any[]) {
//    this._serverLog(LogLevel.Info, logItems);
//};

//GLogger.prototype.sWarn = function (this: any, ...logItems: any[]) {
//    this._serverLog(LogLevel.Warn, logItems);
//};

//GLogger.prototype.sError = function (this: any, ...logItems: any[]) {
//    this._serverLog(LogLevel.Error, logItems);
//};

//GLogger.prototype.sFatal = function (this: any, ...logItems: any[]) {
//    this._serverLog(LogLevel.Fatal, logItems);
//};


// WEBPACK FOOTER //
// ./logr.develop.ts